import { render, staticRenderFns } from "./extra-components.vue?vue&type=template&id=a5e641fc&scoped=true&"
import script from "./extra-components.vue?vue&type=script&lang=js&"
export * from "./extra-components.vue?vue&type=script&lang=js&"
import style0 from "./extra-components.vue?vue&type=style&index=0&id=a5e641fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e641fc",
  null
  
)

export default component.exports